// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"528":"f5c155b07db570be","670":"e81f570679cf369a","888":"02887b780dab4dc4"}[chunkId] + ".css";
};